import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from 'semantic-ui-react';
import Blocks from './Blocks';

const SidebarBlocks = ({
  className,
  defaultWidth,
  sidebar,
  sharedProps,
  blockComponents,
  columnProps,
}) => {
  if (!sidebar) return null;
  const { width, blocks } = sidebar;
  if (!blocks || blocks.length === 0) return null;
  return (
    <Grid.Column className={className} width={width || defaultWidth} {...columnProps}>
      <Blocks blocks={blocks} blockComponents={blockComponents} sharedProps={sharedProps} />
    </Grid.Column>
  );
};

SidebarBlocks.defaultProps = {
  className: '',
  columnProps: undefined,
  defaultWidth: 4,
  sidebar: undefined,
  sharedProps: undefined,
};

SidebarBlocks.propTypes = {
  className: PropTypes.string,
  blockComponents: PropTypes.object.isRequired,
  columnProps: PropTypes.object,
  defaultWidth: PropTypes.number,
  sharedProps: PropTypes.object,
  sidebar: PropTypes.shape({
    width: PropTypes.number,
    blocks: PropTypes.array,
  }),
};

export default SidebarBlocks;
